
import React from 'react';

const TimePickerSelect = ({ value, onChange, step = 5, label }) => {
  // value: "HH:MM AM/PM"
  let hour = '12', minute = '00', ampm = 'AM';
  if (value) {
    const [time, ampmValue] = value.split(' ');
    if (time) {
      [hour, minute] = time.split(':');
    }
    if (ampmValue) {
      ampm = ampmValue;
    } else {
      // If value is in 24hr format, convert
      let h = parseInt(hour, 10);
      ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12;
      if (h === 0) h = 12;
      hour = String(h).padStart(2, '0');
    }
  }

  // For display, show hours as 1-12 (no leading zero), but value is still two-digit for logic
  const hours = Array.from({ length: 12 }, (_, i) => ({
    value: String(i + 1).padStart(2, '0'),
    display: String(i + 1)
  }));
  const minutes = Array.from({ length: 60 / step }, (_, i) => String(i * step).padStart(2, '0'));
  const ampmOptions = ['AM', 'PM'];


  // Helper to convert 12hr to 24hr string
  const to24Hour = (h12, m, ap) => {
    let h = parseInt(h12, 10);
    if (ap === 'AM') {
      if (h === 12) h = 0;
    } else {
      if (h !== 12) h += 12;
    }
    return `${String(h).padStart(2, '0')}:${m}`;
  };

  const handleHourChange = (e) => {
    onChange(to24Hour(e.target.value, minute, ampm));
  };

  const handleMinuteChange = (e) => {
    onChange(to24Hour(hour, e.target.value, ampm));
  };

  const handleAmPmChange = (e) => {
    onChange(to24Hour(hour, minute, e.target.value));
  };

  // Basic styles for the time picker
  const containerStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    background: '#f8f9fa',
    borderRadius: '6px',
    padding: '0.5rem 0.75rem',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  };
  const selectStyle = {
    fontSize: '1rem',
    padding: '0.25rem 0.5rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    background: '#fff',
    margin: 0,
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    cursor: 'pointer',
    transition: 'border 0.2s',
  };
  const colonStyle = {
    fontWeight: 'bold',
    fontSize: '1.1rem',
    margin: '0 0.1rem',
    color: '#555',
  };

  return (
    <label style={{ display: 'block' }}>
      {label && <span style={{ marginRight: '0.5rem', fontWeight: 500 }}>{label}</span>}
      <span style={containerStyle}>
        <select value={hour} onChange={handleHourChange} style={selectStyle}>
          {hours.map(h => <option key={h.value} value={h.value}>{h.display}</option>)}
        </select>
        <span style={colonStyle}>:</span>
        <select value={minute} onChange={handleMinuteChange} style={selectStyle}>
          {minutes.map(m => <option key={m} value={m}>{m}</option>)}
        </select>
        <select value={ampm} onChange={handleAmPmChange} style={selectStyle}>
          {ampmOptions.map(ap => <option key={ap} value={ap}>{ap}</option>)}
        </select>
      </span>
    </label>
  );
};

export default TimePickerSelect;